import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import ThreeYearsTableLayout from '../ThreeYearsTableLayout';
import InputNumberUnit from '../InputNumberUnit';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import range from 'lodash/range';
import LabelDescription from '../LabelDescription';

class ProductionExternally extends Component {
	render() {
		const { Header, Row, Col, Label } = ThreeYearsTableLayout;
		const { game } = this.props;
		const { viewMode } = game;
		const { outsourcingQuota } = game.production;
		return (
			<div className="production-program">
				<BusinessPlanSubSectionTitle label={'production-externally-title'} />
				<ThreeYearsTableLayout>
					<Header />
					<Row>
						<Label>
							<LabelDescription
								label="outsourcing-quota"
								description="outsourcing-quota-desc"
							/>
						</Label>
						{range(1, 4).map(n => {
							return (
								<Col key={n}>
									<InputNumberUnit
										active={!viewMode}
										unit={'%'}
										max={10}
										variable={outsourcingQuota[n - 1]}
									/>
								</Col>
							);
						})}
					</Row>
				</ThreeYearsTableLayout>
			</div>
		);
	}
}

ProductionExternally.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		production: PropTypes.shape({
			outsourcingQuota: MultiYearScalarType
		})
	})
};
export default ProductionExternally;
